import { CommonConstants } from '@/constants/common';

export default {
  mounted(el, binding, vnode) {
    el.addEventListener(
      'blur',
      (e) => {
        let value;
        value = e.target.value.replace(CommonConstants.ALPHANUM_AND_SPECIAL_FULLSIZE_REGEX, '');
        if (e.target.maxLength > 0 && value.length > e.target.maxLength) {
          value = value.slice(0, e.target.maxLength);
        }
        e.target.value = value;
        el.value = value;

        let event;
        if (typeof Event === 'function') {
          event = new Event('input', { bubbles: true });
        } else {
          event = document.createEvent('Event');
          event.initEvent('input', true, true);
        }
        vnode.el.dispatchEvent(event);
      },
      true
    );
  }
};
